import Hero from "../components/Hero";
import ShowcaseDemos from "../components/ShowcaseDemos";
import WhyUs from "../components/WhyUs";
import ActiveLawsuits from "../components/ActiveLawsuits";
import MoreRTLDemos from "../components/MoreRTLDemos";
import HowItWorks from "../components/HowItWorks";
import Testimonials from "../components/Testimonials";
import CallToAction from "../components/CallToAction";

export default function Home() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <Hero />
      <ShowcaseDemos />
      <WhyUs />
      <ActiveLawsuits />
      <MoreRTLDemos />
      <HowItWorks />
      <Testimonials />
      <CallToAction />
    </div>
  );
}
